import React from 'react'

// material-ui
import Typography from '@mui/material/Typography'

// shared components
import PersonCard from 'components/shared/PersonCard'
import AdultStatus from 'components/shared/AdultStatus'

// local components
import EditButton from './EditButton'
import RemoveButton from './RemoveButton'
import DeleteEmergencyContactModal from './DeleteEmergencyContactModal'

export default function EmergencyContactCard(props) {
  const { emergencyContact, setModal, reupRequired, editable } = props
  const relationship = emergencyContact.relationshipToCampers

  return (
    <PersonCard
      header={
        <AdultStatus
          adult={emergencyContact}
          relationship={relationship}
          reupRequired={reupRequired}
        />
      }
      desktopButtons={
        editable ? (
          <>
            <EditButton
              align='right'
              emergencyContact={emergencyContact}
              reupRequired={reupRequired}
            />
            <RemoveButton
              align='right'
              emergencyContact={emergencyContact}
              setModal={setModal}
            />
          </>
        ) : null
      }
      mobileButtons={
        editable ? (
          <>
            <EditButton
              emergencyContact={emergencyContact}
              reupRequired={reupRequired}
            />
            <RemoveButton
              emergencyContact={emergencyContact}
              setModal={setModal}
            />
          </>
        ) : null
      }
    >
      <Typography variant='body1'>{emergencyContact.primaryPhone}</Typography>
      <DeleteEmergencyContactModal emergencyContact={emergencyContact} />
    </PersonCard>
  )
}
